// src/pages/Estoque/venda/DashboardComissao.tsx
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-restricted-globals */
import { useEffect, useState } from 'react';
import {
  Box, Grid, Paper, Typography, useTheme, alpha, Card, CardContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip, ButtonGroup, Button, Pagination,
  useMediaQuery,
  Container,
  Popover,
  IconButton,
} from '@mui/material';
import {
  XAxis, YAxis, CartesianGrid, Tooltip as RechartsTooltip, Legend, ResponsiveContainer, AreaChart, Area,
  PieChart,
  Pie,
  Cell,
} from 'recharts';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import ReceiptIcon from '@mui/icons-material/Receipt';
import PersonIcon from '@mui/icons-material/Person';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import CreditCardIcon from '@mui/icons-material/CreditCard';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/pt-br';

import { LayoutBaseDeDashboard } from '../../../shared/layouts';
import { useGraficoResponsivo } from '../../../shared/components/graficos/useGraficoResponsivo';
import { VendasService, IComissaoItem, IGraficoVendasComissao } from '../../../shared/services/api/estoque/venda/venda';

dayjs.locale('pt-br');
dayjs.extend(utc);

const MESES_ABREVIADOS = [
  'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun',
  'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez',
];

interface VendaDia {
  dia: number;
  valor: number;
  comissao: number;
}

interface VendaItem {
  numero: string;
  nome: string;
  total: number;
  comissao: number;
  status: string;
}

interface TipoVendaItem {
  name: string;
  value: number;
  color: string;
}


export const DashboardComissao: React.FC = () => {
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState(false);
  const [msgType, setMsgType] = useState('');
  const [msg, setMsg] = useState('');
  const [totalCount, setTotalCount] = useState(0);
  const [rankingComissoes, setRankingComissoes] = useState<IComissaoItem[]>([]);
  const [dadosRosca, setDadosRosca] = useState<TipoVendaItem[]>([]);
  const [openMsg, setOpenMsg] = useState(false);
  const isMobile = useMediaQuery(
    theme.breakpoints.down('sm')
  );
  const graficoResp = useGraficoResponsivo();
  const [totaisComissao, setTotaisComissao] = useState({
    vendas: 0,
    total: 0,
    comissao: 0,
  });

  const [mesSelecionado, setMesSelecionado] = useState(
    dayjs().format('YYYY-MM')
  );

  const [anchorMes, setAnchorMes] = useState<HTMLElement | null>(null);
  const [anoPopover, setAnoPopover] = useState(dayjs().year());

  const abrirSeletorMes = (target: HTMLElement) => {
    setAnoPopover(Number(mesSelecionado.split('-')[0]));
    setAnchorMes(target);
  };

  const selecionarMes = (valorMes: string) => {
    setMesSelecionado(valorMes);
    setPagina(1);
    setAnchorMes(null);
  };

  const mesFormatado = (() => {
    const texto = dayjs(`${mesSelecionado}-01`).format('MMMM [de] YYYY');
    return texto.charAt(0).toUpperCase() + texto.slice(1);
  })();

  const [metrica, setMetrica] = useState<
    'valor' | 'comissao'
  >('valor');

  const [dadosDiarios, setDadosDiarios] = useState<
    VendaDia[]
  >([]);

  const [vendas, setVendas] = useState<VendaItem[]>([]);

  const [pagina, setPagina] = useState(1);

  useEffect(() => {

    const carregarTotais = async () => {

      setIsLoading(true);

      const inicioDoMes = dayjs(`${mesSelecionado}-01`).startOf('month');
      const fimDoMes = dayjs(`${mesSelecionado}-01`).endOf('month');

      const result = await VendasService.getAllTotaisComissao(
        inicioDoMes.format('DD/MM/YYYY'),
        fimDoMes.format('DD/MM/YYYY'),
      );

      setIsLoading(false);

      if (result instanceof Error) {

        setMsgType('error');
        setMsg(result.message);
        setOpenMsg(true);

      } else {

        setTotaisComissao({
          vendas: Number(result.totais.vendas || 0),
          total: Number(result.totais.total || 0),
          comissao: Number(result.totais.comissao || 0),
        });
        setRankingComissoes(result.comissao || []);
        setDadosRosca([
          {
            name: 'À Vista',
            value: Number(result.tipovenda?.avista || 0),
            color: theme.palette.success.dark,
          },
          {
            name: 'A Prazo',
            value: Number(result.tipovenda?.aprazo || 0),
            color: theme.palette.warning.dark,
          },
        ]);

      }
    };

    carregarTotais();

  }, [mesSelecionado]);

  useEffect(() => {

    const carregarGrafico = async () => {

      setIsLoading(true);

      const inicioDoMes = dayjs(`${mesSelecionado}-01`).startOf('month');
      const fimDoMes = dayjs(`${mesSelecionado}-01`).endOf('month');

      const result =
        await VendasService.getAllGraficoComissao(
          inicioDoMes.format('DD/MM/YYYY'),
          fimDoMes.format('DD/MM/YYYY'),
        );

      setIsLoading(false);

      if (result instanceof Error) {

        setMsgType('error');
        setMsg(result.message);
        setOpenMsg(true);

      } else {

        console.log('grafico[0]', result.grafico?.[0]);

        const dadosDia: VendaDia[] =
          result.grafico.map((item: any) => ({
            dia: dayjs.utc(item.emissao).date(),
            valor: Number(item.valor || 0),
            comissao: Number(item.comissao || 0),
          }));

        setDadosDiarios(dadosDia);
      }
    };

    carregarGrafico();

  }, [mesSelecionado]);

  useEffect(() => {

    const carregarVendas = async () => {

      setIsLoading(true);

      const inicioDoMes = dayjs(`${mesSelecionado}-01`).startOf('month');
      const fimDoMes = dayjs(`${mesSelecionado}-01`).endOf('month');

      const result =
        await VendasService.getAllVendasComissao(
          inicioDoMes.format('DD/MM/YYYY'),
          fimDoMes.format('DD/MM/YYYY'),
          pagina,
        );
      setIsLoading(false);

      if (result instanceof Error) {
        setMsgType('error');
        setMsg(result.message);
        setOpenMsg(true);
      } else {
        setVendas(result.vendas);
        setTotalCount(result.totalCount);
      }
    };

    carregarVendas();

  }, [pagina, mesSelecionado]);




  const formatCurrency = (value: number) => {
    return value.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  };

  const formatDate = (dateStr?: string) => {
    if (!dateStr) return '--';

    return dayjs(dateStr).format('DD/MM');
  };


  return (
    <LayoutBaseDeDashboard
      barraDeFerramentas={<Box />}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: '100%',
          overflowX: 'hidden',
          overflowY: 'auto',
          bgcolor: 'transparent',
          minHeight: '100vh',
          boxSizing: 'border-box',
        }}
      >
        <Container
          maxWidth={false}
          disableGutters
          sx={{
            width: '100%',
            maxWidth: '100%',
            overflowX: 'hidden',
            px: { xs: 1, sm: 2 },
            boxSizing: 'border-box',
          }}
        >
          {/* CARDS */}
          <Grid
            container
            spacing={2}
            sx={{
              width: '100%',
              m: 0,
              mb: 2,
            }}
          >
            <Grid item xs={12} sm={6} md={3} sx={{ minWidth: 0 }}>
              <Card
                onClick={(e) => abrirSeletorMes(e.currentTarget)}
                sx={{
                  borderRadius: 3,
                  height: '100%',
                  cursor: 'pointer',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: theme.shadows[8],
                  }
                }}
              >
                <CardContent sx={{ height: '100%', display: 'flex', alignItems: 'center' }}>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    width="100%"
                  >
                    <Box>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ fontWeight: 500 }}
                      >
                        Período
                      </Typography>

                      <Box display="flex" alignItems="center" sx={{ mt: 1 }}>
                        <Typography
                          variant="h6"
                          fontWeight="bold"
                          sx={{ lineHeight: 1.2 }}
                        >
                          {mesFormatado}
                        </Typography>

                        <ArrowDropDownIcon
                          sx={{ color: theme.palette.info.dark }}
                        />
                      </Box>
                    </Box>

                    <Box
                      sx={{
                        p: 1.5,
                        borderRadius: 2,
                        bgcolor: alpha(theme.palette.info.main, 0.1),
                      }}
                    >
                      <CalendarTodayIcon
                        sx={{
                          fontSize: 32,
                          color: theme.palette.info.dark
                        }}
                      />
                    </Box>
                  </Box>
                </CardContent>
              </Card>

              <Popover
                open={Boolean(anchorMes)}
                anchorEl={anchorMes}
                onClose={() => setAnchorMes(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
              >
                <Box sx={{ width: 240, p: 2 }}>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={1.5}
                  >
                    <IconButton
                      size="small"
                      onClick={() => setAnoPopover((ano) => ano - 1)}
                    >
                      <ChevronLeftIcon fontSize="small" />
                    </IconButton>

                    <Typography variant="subtitle2" fontWeight="bold">
                      {anoPopover}
                    </Typography>

                    <IconButton
                      size="small"
                      onClick={() => setAnoPopover((ano) => ano + 1)}
                    >
                      <ChevronRightIcon fontSize="small" />
                    </IconButton>
                  </Box>

                  <Grid container spacing={1}>
                    {MESES_ABREVIADOS.map((nomeMes, index) => {
                      const valorMes = `${anoPopover}-${String(index + 1).padStart(2, '0')}`;
                      const selecionado = valorMes === mesSelecionado;

                      return (
                        <Grid item xs={4} key={nomeMes}>
                          <Button
                            fullWidth
                            size="small"
                            variant={selecionado ? 'contained' : 'text'}
                            color="primary"
                            onClick={() => selecionarMes(valorMes)}
                            sx={{ minWidth: 0, px: 0 }}
                          >
                            {nomeMes}
                          </Button>
                        </Grid>
                      );
                    })}
                  </Grid>
                </Box>
              </Popover>
            </Grid>

            <Grid item xs={12} sm={6} md={3} sx={{ minWidth: 0 }}>
              <Card
                sx={{
                  borderRadius: 3,
                  height: '100%',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: theme.shadows[8],
                  }
                }}
              >
                <CardContent>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Box>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ fontWeight: 500 }}
                      >
                        Total de Vendas
                      </Typography>

                      <Typography
                        variant="h4"
                        fontWeight="bold"
                        sx={{ mt: 1 }}
                      >
                        {totaisComissao.vendas}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        p: 1.5,
                        borderRadius: 2,
                        bgcolor: alpha(theme.palette.primary.main, 0.1),
                      }}
                    >
                      <ShoppingCartIcon
                        sx={{
                          fontSize: 32,
                          color: theme.palette.primary.dark
                        }}
                      />
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={3} sx={{ minWidth: 0 }}>
              <Card
                sx={{
                  borderRadius: 3,
                  height: '100%',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: theme.shadows[8],
                  }
                }}
              >
                <CardContent>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Box>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ fontWeight: 500 }}
                      >
                        Valor Total
                      </Typography>

                      <Typography
                        variant="h5"
                        fontWeight="bold"
                        sx={{ mt: 1, color: theme.palette.success.dark }}
                      >
                        {formatCurrency(totaisComissao.total)}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        p: 1.5,
                        borderRadius: 2,
                        bgcolor: alpha(theme.palette.success.main, 0.1),
                      }}
                    >
                      <MonetizationOnIcon
                        sx={{
                          fontSize: 32,
                          color: theme.palette.success.dark
                        }}
                      />
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={3} sx={{ minWidth: 0 }}>
              <Card
                sx={{
                  borderRadius: 3,
                  height: '100%',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: theme.shadows[8],
                  }
                }}
              >
                <CardContent>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Box>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ fontWeight: 500 }}
                      >
                        Comissão Total
                      </Typography>

                      <Typography
                        variant="h5"
                        fontWeight="bold"
                        sx={{ mt: 1, color: theme.palette.warning.dark }}
                      >
                        {formatCurrency(totaisComissao.comissao)}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        p: 1.5,
                        borderRadius: 2,
                        bgcolor: alpha(theme.palette.warning.main, 0.1),
                      }}
                    >
                      <AttachMoneyIcon
                        sx={{
                          fontSize: 32,
                          color: theme.palette.warning.dark
                        }}
                      />
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          {/* GRAFICOS */}
          <Grid
            container
            spacing={2}
            sx={{
              width: '100%',
              m: 0,
              mb: 3,
            }}
          >
            <Grid item xs={12} lg={9} sx={{ minWidth: 0 }}>
              <Paper
                sx={{
                  p: 2,
                  overflow: 'hidden',
                  width: '100%',
                  boxSizing: 'border-box',
                  borderRadius: 3,
                }}
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  flexWrap="wrap"
                  gap={1}
                  mb={2}
                >
                  <Typography
                    variant="subtitle2"
                    fontWeight="bold"
                  >
                    Evolução de Vendas
                  </Typography>

                  <ButtonGroup size="small" sx={graficoResp.grupoBotoes}>
                    <Button
                      variant={metrica === 'valor' ? 'contained' : 'outlined'}
                      onClick={() => setMetrica('valor')}
                    >
                      Total Vendido
                    </Button>

                    <Button
                      variant={metrica === 'comissao' ? 'contained' : 'outlined'}
                      onClick={() => setMetrica('comissao')}
                    >
                      Comissão
                    </Button>
                  </ButtonGroup>
                </Box>

                <Box
                  sx={{
                    width: '100%',
                    height: graficoResp.altura(360),
                  }}
                >
                  <ResponsiveContainer
                    width="100%"
                    height="100%"
                  >
                    <AreaChart margin={graficoResp.margem} data={dadosDiarios}>
                      <defs>
                        <linearGradient
                          id="gradient"
                          x1="0"
                          y1="0"
                          x2="0"
                          y2="1"
                        >
                          <stop
                            offset="5%"
                            stopColor={theme.palette.primary.main}
                            stopOpacity={0.8}
                          />

                          <stop
                            offset="95%"
                            stopColor={theme.palette.primary.main}
                            stopOpacity={0}
                          />
                        </linearGradient>
                      </defs>

                      <CartesianGrid {...graficoResp.grade} strokeDasharray="3 3" />

                      <XAxis {...graficoResp.eixoX} dataKey="dia" />

                      <YAxis {...graficoResp.eixoY}
                        tickFormatter={(value) =>
                          value.toLocaleString('pt-BR', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        }
                      />

                      <RechartsTooltip {...graficoResp.dica}
                        formatter={(value: any) =>
                          Number(value).toLocaleString('pt-BR', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        }
                      />

                      <Legend {...graficoResp.legenda} />

                      <Area
                        type="monotone"
                        dataKey={metrica}
                        stroke={theme.palette.primary.main}
                        fill="url(#gradient)"
                        strokeWidth={2}
                      />
                    </AreaChart>
                  </ResponsiveContainer>
                </Box>
              </Paper>
            </Grid>

            {/* GRAFICO ROSCA */}
            <Grid item xs={12} lg={3} sx={{ minWidth: 0 }}>
              <Paper
                sx={{
                  p: 2,
                  overflow: 'hidden',
                  width: '100%',
                  boxSizing: 'border-box',
                  borderRadius: 3,
                }}
              >
                <Typography
                  variant="subtitle2"
                  fontWeight="bold"
                  mb={2}
                >
                  Tipo de Pagamento
                </Typography>

                <Box
                  sx={{
                    width: '100%',
                    height: 180,
                  }}
                >
                  <ResponsiveContainer
                    width="100%"
                    height="100%"
                  >
                    <PieChart>
                      <Pie {...graficoResp.pizza}
                        data={dadosRosca}
                        dataKey="value"
                        innerRadius={35}
                        outerRadius={55}
                        paddingAngle={3}
                      >
                        {dadosRosca.map((item, index) => (
                          <Cell
                            key={index}
                            fill={item.color}
                          />
                        ))}
                      </Pie>

                      <RechartsTooltip {...graficoResp.dica} />
                    </PieChart>
                  </ResponsiveContainer>
                </Box>

                <Box mt={1}>
                  {dadosRosca.map((item) => (
                    <Box
                      key={item.name}
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      mb={1}
                    >
                      <Box
                        display="flex"
                        alignItems="center"
                        gap={1}
                      >
                        <Box
                          sx={{
                            width: 10,
                            height: 10,
                            borderRadius: '50%',
                            bgcolor: item.color,
                          }}
                        />

                        <Typography variant="caption">
                          {item.name}
                        </Typography>
                      </Box>

                      <Typography
                        variant="caption"
                        fontWeight="bold"
                      >
                        {formatCurrency(item.value)}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Paper>
            </Grid>
          </Grid>

          {/* LISTAGENS - COM ALTURAS IGUAIS */}
          <Grid
            container
            spacing={2}
            sx={{
              width: '100%',
              m: 0,
              pb: 3,
            }}
          >
            {/* ULTIMAS VENDAS - ESTILIZADA */}
            <Grid item xs={12} lg={7} sx={{ minWidth: 0 }}>
              <Paper
                sx={{
                  p: 2,
                  overflow: 'hidden',
                  width: '100%',
                  boxSizing: 'border-box',
                  borderRadius: 3,
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Box
                  display="flex"
                  alignItems="center"
                  gap={1}
                  mb={2}
                  pb={1}
                  borderBottom={`2px solid ${alpha(theme.palette.primary.main, 0.2)}`}
                >
                  <ReceiptIcon color="primary" />

                  <Typography
                    variant="subtitle2"
                    fontWeight="bold"
                    sx={{ flex: 1 }}
                  >
                    Últimas Vendas
                  </Typography>

                  <Chip
                    label={`${totalCount} vendas`}
                    size="small"
                    color="primary"
                    variant="outlined"
                  />
                </Box>

                <TableContainer
                  sx={{
                    width: '100%',
                    overflowX: 'auto',
                    flex: 1,
                  }}
                >
                  <Table stickyHeader size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 'bold' }}>
                          Nº Venda
                        </TableCell>

                        {!isMobile && (
                          <TableCell sx={{ fontWeight: 'bold' }}>
                            Cliente
                          </TableCell>
                        )}

                        <TableCell
                          align="right"
                          sx={{ fontWeight: 'bold' }}
                        >
                          Total
                        </TableCell>

                        <TableCell
                          align="right"
                          sx={{ fontWeight: 'bold' }}
                        >
                          Comissão
                        </TableCell>

                        <TableCell
                          align="center"
                          sx={{ fontWeight: 'bold' }}
                        >
                          Status
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {vendas.map((item) => (
                        <TableRow
                          key={item.numero}
                          sx={{
                            '&:hover': {
                              bgcolor: alpha(
                                theme.palette.primary.main,
                                0.04
                              ),
                              transition:
                                'background-color 0.2s',
                            },
                          }}
                        >
                          <TableCell>
                            <Typography
                              variant="body2"
                              fontWeight="medium"
                            >
                              {item.numero}
                            </Typography>
                          </TableCell>

                          {!isMobile && (
                            <TableCell>
                              <Box
                                display="flex"
                                alignItems="center"
                                gap={0.5}
                              >
                                <PersonIcon
                                  sx={{
                                    fontSize: 14,
                                    color: 'text.secondary',
                                  }}
                                />

                                <Typography variant="body2">
                                  {item.nome}
                                </Typography>
                              </Box>
                            </TableCell>
                          )}

                          <TableCell align="right">
                            <Typography
                              variant="body2"
                              fontWeight="medium"
                              color="success.dark"
                            >
                              {formatCurrency(item.total)}
                            </Typography>
                          </TableCell>

                          <TableCell align="right">
                            <Typography
                              variant="body2"
                              fontWeight="medium"
                              color="warning.dark"
                            >
                              {formatCurrency(item.comissao)}
                            </Typography>
                          </TableCell>

                          <TableCell align="center">
                            <Chip
                              icon={
                                item.status === 'A Vista'
                                  ? <LocalAtmIcon />
                                  : <CreditCardIcon />
                              }
                              label={item.status}
                              size="small"
                              color={
                                item.status === 'A Vista'
                                  ? 'success'
                                  : 'warning'
                              }
                              variant="outlined"
                              sx={{ minWidth: 80 }}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                {vendas.length === 0 && (
                  <Box sx={{ textAlign: 'center', py: 4 }}>
                    <Typography color="text.secondary">
                      Nenhuma venda encontrada
                    </Typography>
                  </Box>
                )}

                <Box
                  display="flex"
                  justifyContent="center"
                  mt={2}
                  pt={1}
                  borderTop={`1px solid ${alpha(
                    theme.palette.divider,
                    0.1
                  )}`}
                >
                  <Pagination
                    page={pagina}
                    onChange={(_, value) =>
                      setPagina(value)
                    }
                    count={Math.ceil(
                      totalCount / 10
                    )}
                    size="small"
                    color="primary"
                  />
                </Box>
              </Paper>
            </Grid>

            {/* MAIORES COMISSÕES - MELHORADA */}
            <Grid item xs={12} lg={5} sx={{ minWidth: 0 }}>
              <Paper
                sx={{
                  p: 2,
                  overflow: 'hidden',
                  width: '100%',
                  boxSizing: 'border-box',
                  borderRadius: 3,
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Box
                  display="flex"
                  alignItems="center"
                  gap={1}
                  mb={2}
                  pb={1}
                  borderBottom={`2px solid ${alpha(theme.palette.success.main, 0.2)}`}
                >
                  <TrendingUpIcon color="success" />
                  <Typography
                    variant="subtitle2"
                    fontWeight="bold"
                    sx={{ flex: 1 }}
                  >
                    Maiores Comissões
                  </Typography>
                  <Chip
                    label="Top 5"
                    size="small"
                    color="success"
                    variant="outlined"
                  />
                </Box>

                {rankingComissoes
                  .sort(
                    (a, b) =>
                      b.comissao - a.comissao
                  )
                  .slice(0, 5)
                  .map((item, index) => (
                    <Box
                      key={`${item.numero}-${index}`}
                      sx={{
                        p: 1.5,
                        borderRadius: 2,
                        mb: 1.5,
                        bgcolor: alpha(
                          theme.palette.background.paper,
                          0.4
                        ),
                        transition: 'all 0.2s',
                        cursor: 'pointer',
                        '&:hover': {
                          bgcolor: alpha(theme.palette.success.main, 0.08),
                          transform: 'translateX(4px)',
                        },
                      }}
                    >
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Box
                          display="flex"
                          alignItems="center"
                          gap={1.5}
                          flex={1}
                        >
                          <Chip
                            label={`#${index + 1}`}
                            size="small"
                            color="success"
                            sx={{
                              fontWeight: 'bold',
                              minWidth: 40,
                            }}
                          />

                          <Box sx={{ flex: 1 }}>
                            <Typography
                              variant="body2"
                              fontWeight="bold"
                              display="flex"
                              alignItems="center"
                              gap={1}
                            >
                              <ReceiptIcon
                                sx={{
                                  fontSize: 14,
                                  color: 'text.secondary',
                                }}
                              />

                              {item.numero}
                            </Typography>

                            <Typography
                              variant="caption"
                              display="flex"
                              alignItems="center"
                              gap={0.5}
                              color="text.secondary"
                              sx={{ mt: 0.5 }}
                            >
                              <PersonIcon sx={{ fontSize: 12 }} />

                              {item.nome}
                            </Typography>
                          </Box>
                        </Box>

                        <Box textAlign="right">
                          <Typography
                            variant="body2"
                            fontWeight="bold"
                            color="warning.dark"
                          >
                            {formatCurrency(item.comissao)}
                          </Typography>

                          <Typography
                            variant="caption"
                            color="text.secondary"
                          >
                            {formatDate(item.emissao)}
                          </Typography>
                        </Box>
                      </Box>

                      <Box
                        sx={{
                          mt: 1,
                          height: 3,
                          borderRadius: 1,
                          bgcolor: alpha(theme.palette.grey[500], 0.2),
                          overflow: 'hidden',
                        }}
                      >
                        <Box
                          sx={{
                            width: `${(
                              (item.comissao /
                                (rankingComissoes[0]?.comissao || 1)
                              ) * 100
                            )}%`,
                            height: '100%',
                            bgcolor: theme.palette.success.main,
                            borderRadius: 1,
                            transition: 'width 0.3s',
                          }}
                        />
                      </Box>
                    </Box>
                  ))}
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </LayoutBaseDeDashboard>
  );
};